import bTable from './table.vue';

export default bTable;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/table/table.js
// module id = UqMQ
// module chunks = 0